// extracted by mini-css-extract-plugin
export default {"settingsForm":"SettingsForm_settingsForm__Igqu-"};